import { render, staticRenderFns } from "./CardBase.vue?vue&type=template&id=ae04dd3c"
import script from "./CardBase.vue?vue&type=script&lang=js"
export * from "./CardBase.vue?vue&type=script&lang=js"
import style0 from "./CardBase.vue?vue&type=style&index=0&id=ae04dd3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports